import React, { useState } from "react";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Dialog, DialogProps, Grid, makeStyles } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

import { ButtonCancel, ButtonSubmit, Multiline } from "components/shared";
import { PageHeader } from "components/shared/PageHeader";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      margin: 0,
      padding: theme.spacing(3),
      marginBottom: "-50px",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const useStyles = makeStyles({
  timeButton: {
    fontWeight: "bold",
    background: "#d2d2d2",
    border: "1px solid gray",
    borderRadius: "3px",
    height: "20px",
    "&:hover": {
      background: "#beb9b9",
      cursor: "pointer",
    },
    "&:active": {
      background: "#ff6500",
    },
  },

  infoContainer: {
    marginLeft: 8,
    border: "1px solid gray",
    width: "550px",
    padding: "20px",
    marginTop: "10px",
    borderRadius: "5px",
  },
  titles: {
    fontSize: "1.7rem",
    width: "160px",
    fontWeight: "bold",
  },
  infos: {
    fontSize: "1.7rem",
    color: "rgb(97, 97, 97)",
  },
  typo: {
    display: "flex",
  },
  hourContainer: {
    fontSize: "1.7rem",
    display: "flex",
    width: "900px",
    justifyContent: "space-between",
  },
  maxTime: {
    fontSize: "1.7rem",
  },
  btnsContainer: {
    marginTop: 30,
    display: "flex",
    justifyContent: "flex-end",
    gap: 20,
    width: "550px",
  },
  "@media (max-width: 661px)": {
    infoContainer: {
      width: "100%",
    },
    titles: {
      fontSize: "1.5rem",
    },
    infos: {
      fontSize: "15px",
    },
    typo: {
      display: "flex",
      flexDirection: "column",
    },
    hourContainer: {
      fontSize: "1.5rem",
      width: "40%",
      flexDirection: "column",
      marginBottom: "20px",
      gap: 5,
    },
    infoHours: {
      alignSelf: "flex-start",
      marginTop: "-10px",
    },
    maxTime: {
      fontSize: "1.5rem",
    },
    btnsContainer: {
      justifyContent: "flex-start",
    },
  },
});

// const Title = styled.h3`
//   color: var(--grayLv3);
//   margin-bottom: 4px;
// `;
// const Value = styled.p`
//   color: var(--grayLv3);
//   font-size: 1.2rem;
// `;
const P = styled.p`
  color: var(--grayLv3);
  font-size: 1.4rem;
  line-height: 2.4rem;
`;
const MessageContainer = styled.div`
  margin-top: 16px;
`;

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {/* {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon fontSize="large" style={{color: 'var(--black)'}}/>
        </IconButton>
      ) : null} */}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
  },
}))(MuiDialogActions);

interface DialogDetailsProps extends DialogProps {
  open: boolean;
  idTransacao: string | number;
  addreesse: string;
  data: any;
  onRenew: (idTransacao: string | number, motive: string) => Promise<void>;
  setOpen: (value: boolean) => void;
  maxWidth?: false | "md" | "xs" | "sm" | "lg" | "xl" | undefined;
}

export default function DialogMotiveToRenewCredential({
  title,
  open,
  setOpen,
  maxWidth = "sm",
  idTransacao,
  onRenew,
  addreesse,
  data,
}: DialogDetailsProps) {
  const classes = useStyles();
  const [value, setValue] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 50) {
      e.stopPropagation();
    } else {
      setValue(e.target.value);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    onRenew(idTransacao, value);
    setValue("");
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={maxWidth}
      fullWidth
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <PageHeader title="Renovar prazo de retirada" showUserData={false} />
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <div className={classes.infoContainer}>
            <Typography variant="h5" className={classes.typo}>
              <div className={classes.titles}>Cód. Transação</div>
              <div className={classes.infos}>{idTransacao}</div>
            </Typography>
            <Typography
              variant="h5"
              className={classes.typo}
              style={{ marginTop: "12px" }}
            >
              <div className={classes.titles}>Destinatário</div>
              <div className={classes.infos}>{addreesse}</div>
            </Typography>
            <Typography
              variant="h5"
              className={classes.typo}
              style={{ marginTop: "12px" }}
            >
              <div className={classes.titles}>Box</div>
              <div className={classes.infos}>{data?.NUMERO}</div>
            </Typography>
            <Typography
              variant="h5"
              className={classes.typo}
              style={{ marginTop: "12px" }}
            >
              <div className={classes.titles}>Tamanho </div>
              <div className={classes.infos}>{data?.DESCRICAO}</div>
            </Typography>
          </div>
          {/* <Grid item xs={12} md={6} lg={3} xl={2}>
            <Title>ID da Transação</Title>
            <Value>{idTransacao}</Value>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <Title>Destinatário</Title>
            <Value>{addreesse}</Value>
          </Grid> */}
        </Grid>
        <Grid>
          <Multiline
            fullWidth
            label={
              <span>
                Motivo <span style={{ color: "red" }}>*</span>
              </span>
            }
            name="motive"
            variant="outlined"
            value={value}
            onChange={handleChange}
          />
          <p style={{ marginBottom: 5, fontSize: 10 }}>
            Você ainda pode digitar {50 - value.length} caracteres.
          </p>
        </Grid>
        <span style={{ color: "red" }}>* Preenchimento obrigatório</span>
        <MessageContainer>
          <P>A credencial será reenviada ao Destinatário.</P>
          <P>Confirmar?</P>
        </MessageContainer>
      </DialogContent>

      <DialogActions>
        <ButtonCancel onClick={handleClose}>Não</ButtonCancel>
        <ButtonSubmit
          onClick={handleSubmit}
          color="primary"
          disabled={value.length < 1}
        >
          Sim
        </ButtonSubmit>
      </DialogActions>
    </Dialog>
  );
}
